export enum ContractGroupEnum {
  vertical = 'VERTICAL',
  horizontal = 'HORIZONTAL',
  device = 'DEVICE',
  services = 'SERVICES',
  auxiliar = 'AUXILIAR'
};